import {utils} from '@wallaby-ui/core';
import {find, isEmpty} from 'lodash';
import {IntlShape} from 'react-intl';

import Filter from './filter';
import {FilterOptions} from '../filter_types';
import {FILTER_TYPE_RADIO} from 'src/js/lib/filtering/filters_definitions_constants';
import {FilterSchema} from 'src/js/model/filters_config';

class SelectFilter extends Filter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_RADIO;
  }

  static fromString(serializedFilter) {
    const nameValueSepIdx = serializedFilter.indexOf(':');
    const property = serializedFilter.slice(0, nameValueSepIdx);
    if (serializedFilter.slice(nameValueSepIdx + 1) === '*') {
      return new SelectFilter({property, value: null});
    }
    // remove parenthesis
    const value = serializedFilter.slice(nameValueSepIdx + 2, -1);
    return new SelectFilter({
      property,
      value,
    });
  }

  static fromSchema(schemaNode) {
    return new SelectFilter({property: schemaNode.getName()});
  }

  clone() {
    return new SelectFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  getValue() {
    return this.value;
  }

  isEqual(otherFilter) {
    return this.property === otherFilter.property;
  }

  toString() {
    if (this.value != null) {
      return `${this.property}:'${this.value}'`;
    }
    return `${this.property}:*`;
  }

  toComponentString(
    filterSchema: FilterSchema,
    translateService: IntlShape,
    options?: FilterOptions
  ) {
    const node = filterSchema.getFilterByName(this.property);
    let messageId = node.getLabel();
    const label = utils.TranslateUtils.translate(messageId, translateService);
    let childLabel;
    if (!isEmpty(node.getChildrenIds())) {
      messageId = node.getChildLabel(filterSchema, this.value);
      childLabel = utils.TranslateUtils.translate(messageId, translateService);
    } else if (options?.isAsync) {
      const itemOption =
        find(
          options?.mappedEnumOptions,
          (option) => option.value === this.value
        ) || {};
      childLabel = itemOption.label || this.value;
    } else if (options?.isHierarchy) {
      const nodeAutocompleteValues = node.getHierarchyType()
        ? options?.autocompleteValues?.[node.getHierarchyType()]
        : [];
      childLabel = this.value;
      if (!isEmpty(nodeAutocompleteValues)) {
        const itemOption =
          find(
            nodeAutocompleteValues.getMappedOptions(),
            (option) => option.getValue() === this.value
          ) || {};
        if (!isEmpty(itemOption)) {
          childLabel = itemOption.getLabel();
        }
      }
    }
    return `${label}: ${childLabel}`;
  }
}

export default SelectFilter;
